<template>
  <div>
    <div
      v-if="loaded && loadFailed"
      class="alert alert-danger d-flex flex-wrap align-items-center justify-content-between"
      role="alert"
    >
      <span class="my-1">دریافت مقصد‌ها انجام نشد.</span>
      <button
        type="button"
        class="btn btn-sm btn-light font-weight-bold my-1"
        @click="updateDestinations()"
      >
        تلاش دوباره
      </button>
    </div>

    <div>
      <div v-if="loaded && !loadFailed && destinations.length === 0">
        <div class="alert alert-primary" role="alert">
          مقصدی یافت نشد، برای افزودن مقصد
          <router-link
            :to="{ name: 'destinations-create' }"
            class="alert-link text-light-primary"
          >
            کلیک
          </router-link>
          کنید
        </div>
      </div>
    </div>

    <b-overlay
      :show="!loaded"
      opacity="0.4"
      :class="{ 'min-h-200px': !loaded }"
    >
      <div v-if="!loadFailed" class="row">
        <div
          v-for="destination in destinations"
          :key="destination.id"
          class="col-6 col-sm-4 col-md-3 col-xl-2"
        >
          <div
            class="card card-custom card-stretch gutter-b destination-card text-center"
          >
            <router-link
              class="d-block h-100"
              :to="{
                name: 'destinations-show',
                params: { id: destination.id }
              }"
            >
              <div class="card-body p-4">
                <div class="symbol symbol-40 text-center">
                  <img
                    class="mx-auto"
                    :alt="destination.name"
                    :src="
                      `/media/destinations/${
                        destinationTypes[destination.type]
                      }.png`
                    "
                  />
                </div>
                <div class="mt-4 font-size-sm text-break">
                  {{ destination.name }}
                </div>
              </div>
            </router-link>
          </div>
        </div>
      </div>
    </b-overlay>

    <div
      class="overflow-auto mt-5"
      v-if="
        destinationsPagination.lastPage > 1 ||
          destinationsPagination.currentPage > 1
      "
    >
      <b-pagination
        v-model="destinationsPagination.currentPage"
        :total-rows="destinationsPagination.total"
        :per-page="destinationsPagination.perPage"
        aria-controls="my-table"
        :disabled="!loaded"
        @input="updateDestinations()"
      ></b-pagination>
    </div>
  </div>
</template>

<script>
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import { SET_ACTIONS } from "@/core/services/store/actions.module";
import { FETCH_DESTINATIONS } from "@/core/services/store/destinations.module";
import { mapGetters } from "vuex";

export default {
  name: "destinations",
  data() {
    return {
      loaded: false,
      loadFailed: false
    };
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [{ title: "مقصد‌ها" }]);
    this.$store.dispatch(SET_ACTIONS, {
      links: [
        {
          name: '<i class="flaticon2-plus"></i>افزودن',
          to: { name: "destinations-create" },
          class: "btn-primary"
        }
      ]
    });
    this.updateDestinations();
  },
  computed: {
    ...mapGetters([
      "destinations",
      "destinationsPagination",
      "destinationTypes"
    ])
  },
  methods: {
    updateDestinations() {
      this.loaded = false;
      this.loadFailed = false;

      this.$store
        .dispatch(FETCH_DESTINATIONS, {
          editable: true
        })
        .then(() => {
          this.loaded = true;
        })
        .catch(() => {
          this.loadFailed = true;
          this.loaded = true;
        });
    }
  }
};
</script>
